import { render, staticRenderFns } from "./WinnerSelectionDialog.vue?vue&type=template&id=2157c7c1&scoped=true"
import script from "./WinnerSelectionDialog.vue?vue&type=script&lang=js"
export * from "./WinnerSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./WinnerSelectionDialog.vue?vue&type=style&index=0&id=2157c7c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157c7c1",
  null
  
)

export default component.exports